import BaseModel from '../core/BaseModel'
//import {constants} from "../services/constants";
//import CategoriesModel from './CategoriesModel'
export default class MaintenanceModel extends BaseModel {
    constructor() {
        super({
                name: "maintenance",
                tableName: 'core_maintenance'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                date_maintenance: {
                    name: 'date_maintenance',
                    type: "Date",
                    label: 'Ngày bảo trì',
                    width: 15,
                    sortable: true,
                    filter: {type: 'DateRange', match: 'custom'}
                },
                parts_number_info: {
                    name: 'parts_number_info',
                    type: "String",
                    label: 'Đợt bảo trì',
                    class: 'center',
                    sortable: false,
                    width: 8,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập số'},
                    computed: (data) => {
                        data.parts_number_info = (data.parts_number) ? 'Đợt ' + data.parts_number : '';
                    }
                },
                type_maintenance: {
                    name: 'type_maintenance',
                    label: 'Loại bảo trì',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 10,
                    disabled: true,
                    sortable: true,
                    options: [{value: 0, label: 'Bảo trì tận nơi'}, {value: 1, label: 'Bảo trì tại TTBH'}],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                customer_info: {
                    name: 'customer_info',
                    type: "String",
                    label: 'Khách hàng',
                    sortable: false,
                    width: 12,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập tên hoặc SĐT'},
                    computed: (data) => {
                        var str_customer = "";
                        if (data.serial_customer) {
                            var serial_customer = JSON.parse(data.serial_customer);
                            str_customer += (serial_customer.phone_number) ? serial_customer.phone_number.replace('+84', '0') + " - " : '';
                            str_customer += (serial_customer.full_name) ? serial_customer.full_name : '';
                        }
                        /*if (data.obj_customer_user) {
                            if (data.obj_customer_user.obj_customer_profile){
                                var serial_customer = data.obj_customer_user.obj_customer_profile;
                                str_customer += (serial_customer.phone_number) ? serial_customer.phone_number.replace('+84', '0') + " - " : '';
                                str_customer += (serial_customer.full_name) ? serial_customer.full_name : '';
                            }
                        }*/
                        data.customer_info = str_customer;
                    }
                },
                address_info: {
                    name: 'address_info',
                    type: "String",
                    label: 'Địa chỉ',
                    sortable: false,
                    width: 12,
                    filter: {type: 'input', match: 'contains', placeHolder: 'Nhập địa chỉ'},
                    computed: (data) => {
                        var str_text = "";
                        if (data.serial_customer) {
                            var serial_customer = JSON.parse(data.serial_customer);
                            str_text += (serial_customer.full_address) ? serial_customer.full_address : '';
                        }
                        /*if (data.obj_customer_user) {
                            if (data.obj_customer_user.obj_customer_profile){
                                    var item_customer_profile = data.obj_customer_user.obj_customer_profile;
                                    var name_province = (!constants.isEmpty(item_customer_profile.province)) ? item_customer_profile.province.name:'';
                                    var name_district = (!constants.isEmpty(item_customer_profile.district)) ? item_customer_profile.district.name:'';
                                    var name_ward = (!constants.isEmpty(item_customer_profile.ward)) ? item_customer_profile.ward.name:'';
                                    var delivery_apartment_number = (!constants.isEmpty(item_customer_profile.address)) ? item_customer_profile.address.trim():'';

                                    if (
                                        !constants.isEmpty(name_province)
                                        && !constants.isEmpty(name_district)
                                        && !constants.isEmpty(name_ward)
                                        && !constants.isEmpty(delivery_apartment_number)
                                    ){
                                        str_text = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
                                    }
                            }
                        }*/

                        data.address_info = str_text;
                    }
                },
                model_code_info: {
                    name: 'model_code_info',
                    type: "String",
                    label: 'Model sản phẩm',
                    sortable: true,
                    width: 10,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập model'},
                    computed: (data) => {
                        var str_text = "";
                        if (data.product_serial_number) {
                            str_text += (data.product_serial_number.product) ? data.product_serial_number.product.model_code : '';
                        }
                        data.model_code_info = str_text;
                    }
                },
                name_product_info: {
                    name: 'name_product_info',
                    type: "String",
                    label: 'Tên sản phẩm',
                    sortable: true,
                    width: 12,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập tên sản phẩm'},
                    computed: (data) => {
                        var str_text = "";
                        if (data.product_serial_number) {
                            str_text += (data.product_serial_number.product) ? data.product_serial_number.product.name : '';
                        }
                        data.name_product_info = str_text;
                    }
                },
                serial_number_info: {
                    name: 'serial_number_info',
                    type: "String",
                    label: 'Serial number',
                    sortable: false,
                    width: 10,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập serial number'},
                    computed: (data) => {
                        var str_text = "";
                        if (data.product_serial_number) {
                            str_text += (data.product_serial_number.serial_number) ? data.product_serial_number.serial_number : '';
                        }
                        data.serial_number_info = str_text;
                    }
                },
                process_status: {
                    name: 'process_status',
                    label: 'Trạng thái bảo trì',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 12,
                    disabled: true,
                    sortable: true,
                    options: [{value: 0, label: 'Kế hoạch', style: 'color: #00CC00; font-weight: 500;'}, {
                        value: 1,
                        label: 'Cần bảo trì',
                        style: 'color: #FF6600; font-weight: 500;'
                    }, {value: 2, label: 'Đang thực hiện', style: 'color: #990099; font-weight: 500;'}, {
                        value: 3,
                        label: 'Đã bảo trì',
                        style: 'color: #0066FF;font-weight: 500;'
                    }, {value: 4, label: 'Quá hạn', style: 'color: #CC0000;font-weight: 500;'}, {
                        value: 5,
                        label: 'Hủy kế hoạch',
                        style: 'color: #666666;font-weight: 500;'
                    }],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                is_assignment : {
                    name: 'is_assignment',
                    label: 'Đã phân công',
                    type: "Selection",
                    dataType: 'Checkbox',
                    class: 'center disabled-opacity',
                    width: 12,
                    key_display_checkbox:'show_check_box_assignment',
                    //disabled: true,
                    callback: true,
                    sortable: false,
                    options: [{value: false, label: 'Không'}, {
                        value: true,
                        label: 'Có'
                    }],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                show_check_box_assignment: {
                    name: 'show_check_box_assignment',
                    type: "String",
                    label: 'Khách hàng',
                    sortable: false,
                    display: false,
                    width: 12,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập tên hoặc SĐT'},
                    computed: (data) => {
                        if (data.type_maintenance == 0){
                            data.show_check_box_assignment = true;
                        }else {
                            data.show_check_box_assignment = false;
                            data.is_assignment = 3;//gán =3 để ko filter
                        }

                    }
                },
                fied_detail: {
                    refs: 'type_maintenance serial_user_id parts_number serial_customer list_service_pack_id product_serial_number { id serial_number product { id model_code name } }  ',//obj_customer_user {full_name phone_number obj_customer_profile { id full_name phone_number address province { id name } district { id name } ward { id name }}}
                    display: false
                },
            },)
    }

}